import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FeedMetadataService } from '../../../../services/feed-metadata.service';
import { FeedService } from '../../service/feed.service';
import { AdminCommonHttpService } from '../../service/admin-common-http.service';

@Component({
  selector: 'app-feed-destination-select',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './feed-destination-select.component.html',
  styleUrls: ['./feed-destination-select.component.scss']
})
export class FeedDestinationSelectComponent implements OnInit {

  productId!: number;
  destinations: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: AdminCommonHttpService
  ) { }

  async ngOnInit() {
    this.productId = Number(this.route.snapshot.paramMap.get('productId'));

    this.destinations = await this.http.getFeedDestinations();

  }

  go(dest: string) {
    this.router.navigate(
      ['/admin/feeds/product', this.productId, 'edit'],
      { queryParams: { destination: dest } }
    );
  }
}
